import { z } from "zod";
const attributesCodeGroupSchema = z.object({
  children: z.array(
    z.object({
      id: z.string(),
      lang: z.string().optional(),
      title: z.string().optional()
    })
  ),
  isMdx: z.boolean().optional()
});
export {
  attributesCodeGroupSchema
};
//# sourceMappingURL=attributes.js.map
